export const baseClassNames = {
	root: 'tree',
	node: 'tree-node',
	branch: 'tree-node__branch',
	branchWrapper: 'tree-branch-wrapper',
	leafListItem: 'tree-leaf-list-item',
	leaf: 'tree-node__leaf',
	nodeGroup: 'tree-node-group',
};

export const treeTypes = {
	collapse: 'COLLAPSE',
	collapseMany: 'COLLAPSE_MANY',
	expand: 'EXPAND',
	expandMany: 'EXPAND_MANY',
	halfSelect: 'HALF_SELECT',
	select: 'SELECT',
	deselect: 'DESELECT',
	toggle: 'TOGGLE',
	toggleSelect: 'TOGGLE_SELECT',
	changeSelectMany: 'SELECT_MANY',
	exclusiveSelectMany: 'EXCLUSIVE_SELECT_MANY',
	exclusiveChangeSelectMany: 'EXCLUSIVE_CHANGE_SELECT_MANY',
	focus: 'FOCUS',
	blur: 'BLUR',
	disable: 'DISABLE',
	enable: 'ENABLE',
};

export const clickActions = {
	select: 'SELECT',
	focus: 'FOCUS',
	exclusiveSelect: 'EXCLUSIVE_SELECT',
};

export type noop = () => any;

export interface nodeRendererItem {
	element: any;
	getNodeProps: noop;
	isExpanded: boolean;
	isBranch: boolean;
}

type TreeViewSize = 'default' | 'compact';

export interface TreeviewProps extends React.ComponentProps<'ul'> {
	/** Tree data*/
	data: any[];

	/** Function called when a node changes its selected state */
	onSelect?: (element: any) => void;

	/** Function called when a node changes its expanded state */
	onExpand?: (element: any) => void;

	/** className to add to the outermost ul*/
	className?: string;

	/** Render prop for the node */
	nodeRenderer: (element: any) => void;

	/** Array with the ids of the default expanded nodes*/
	defaultExpandedIds?: any[];

	/** Array with the ids of the default selected nodes*/
	defaultSelectedIds?: any[];

	/** Array with the ids of the default disabled nodes*/
	defaultDisabledIds?: any[];

	/** If true; collapsing a node will also collapse its descendants */
	propagateCollapse?: boolean;

	/** If true; selecting a node will also select its descendants */
	propagateSelect?: boolean;

	/** If true; selecting a node will update the state of its parent (e.g. a parent node in a checkbox will be automatically selected if all of its children are selected)*/
	propagateSelectUpwards?: boolean;

	/** Allows multiple nodes to be selected */
	multiSelect?: boolean;

	/** Selecting a node with a keyboard (using Space or Enter) will also toggle its expanded state */
	expandOnKeyboardSelect?: boolean;

	/** Wether the selected state is togglable */
	togglableSelect?: boolean;

	/** action to perform on click */
	clickAction?: 'SELECT' | 'FOCUS' | 'EXCLUSIVE_SELECT';

	onBlur?: (event: any) => void;

	/** */
	size?: TreeViewSize;
}

export interface NodeProps extends React.ComponentProps<'li'> {
	element: any;
	dispatch: any;
	data: any;
	selectedIds: any;
	tabbableId: any;
	isFocused: any;
	expandedIds: any;
	disabledIds: any;
	halfSelectedIds: any;
	lastUserSelect: any;
	nodeRefs: any;
	baseClassNames: any;
	nodeRenderer: any;
	setsize: any;
	posinset: any;
	level: any;
	propagateCollapse: any;
	propagateSelect: any;
	multiSelect: any;
	togglableSelect: any;
	clickAction: any;
	state: any;
	size: any;
}
